<template>
    <div>
        <select :value="type" @change="typeChanged" class="ag-filter-select">
            <option :key="option" :value="option"  :text="option" v-for="option in params.filterOptions">{{params.localeText[option]}}</option>
        </select>
        <vs-input :type="params.inputType" :value="value" @change="valueChanged" class="agFilter"></vs-input>
    </div>
</template>

<script>
    import Vue from "vue";

    export default Vue.extend({
        name: "AgFilterComponent",
        data(){
            return {
                type: 'equals',
                value: null,
                valueGetter: null
            }
        },
        methods: {
            isFilterActive(){
              return false;
            },
            typeChanged(event, value){
                this.type = event.target.value;
                this.params.filterChangedCallback();
                this.params.frameworkComponentWrapper.parent.$parent.filterModified();
            },
            valueChanged(event){
                this.value = event.target.value;
                this.params.filterChangedCallback();
                this.params.frameworkComponentWrapper.parent.$parent.filterModified();
            },
            getModel() {
                return {
                    typeFilter: 'number',
                    type: this.type,
                    value: this.value,
                };
            },
            setModel(model) {
                if(model) {
                    this.value = model.value;
                    this.type = model.type;
                    this.$nextTick(() => {this.params.filterChangedCallback()});
                }
            },
        },
        created() {
            this.valueGetter = this.params.valueGetter;
        },
        mounted() {
            this.type = this.params.defaultType;
        }
    })
</script>